import { MASTER_DATA_API_URL } from "utils/constants";
import { downloadFilePost, post } from '../../utils/api';
import { DataResponse } from "services/response";
import { SearchModel } from "pages/model";
import { DeliveryRegistrationReport, DeliveryResultReport, EmailSendingReport, ReceivingScheduleOfBHFReport, WasteHandoverRegistrationReport } from "models/Report";

// Tìm kiếm của báo cáo lịch sử giao hàng
export type SearchDeliveryRegistrationReport = SearchModel & Partial<{
  weightStatus: string;
  receiveStatus: string;
  vendorNumber: string;
  vendorName: string;
  deliveryDateFrom: string;
  deliveryDateTo: string
}>

// Tìm kiếm của báo cáo danh sách đăng ký bàn giao chất thải/phế liệu
export type SearchWasteHandoverRegistrationReport = SearchModel & Partial<{
  wasteHandoverRegistrationCode: string;
  vendorNumbers: string[];
  licensePlate: string;
  taskStatusCategories: string[];
  actived: boolean;
  deliveryDateFrom: string;
  deliveryDateTo: string;
}>

// tìm kiếm của báo cáo kết quả giao hàng
export type SearchDeliveryResultReport = SearchModel & Partial<{
  deliveryRegistrationCode: string;
  purchaseOrderCode: string;
  productCode: string;
  productName: string;
  vendorNumber: string;
  vendorName: string;
  taskStatusCategory: string;
  receiveStatus: string;
  receiveDateFrom: string;
  receiveDateTo: string
}>
// tìm kiếm của báo cáo receiving-schedule-of-bhf
export type SearchReceivingScheduleOfBHFReport = SearchModel & Partial<{
  purchaseOrderCode: string;
  productCode: string;
  productName: string;
  vendorNumber: string;
  stockCode: string;
  deliveredTime: string;
  type: string
}>

export type SearchEmailSendingReport = SearchModel & Partial<{
  plantCode: string;
  status: boolean;
  type: string;
  fromTime: string;
  toTime: string;
}>

export type SearchWasteSummaryReport = SearchModel & Partial<{
  fromDeliveredTime: string | null;
  toDeliveredTime: string | null;
  vendorNumber: string | null;
  wasteProductCode: string | null;
  wasteProductName: string | null;
  wasteGroup: any;
  wasteGroupingContractId: string | null;
  wasteGroupingEnvironmentPermitId: string | null;
  taskStatusCode: string | null;
  actived: boolean | null;
}>

// API Response Item Type for Waste Summary Report
export type WasteSummaryReportItem = {
  stt: number;
  wasteHandoverRegistrationId: string;
  wasteHandoverRegistrationCode: string;
  deliveredTime: string;
  vendorNumber: string;
  vendorName: string;
  vendorFmt: string;
  wasteGroupingContractId: string;
  wasteGroupingContractCode: number;
  wasteGroupingContractName: string;
  wasteGroupingEnvironmentPermitId: string;
  wasteGroupingEnvironmentPermitCustomCode: string;
  wasteGroupingEnvironmentPermitName: string;
  wasteProductCode: string;
  wasteProductName: string;
  unit: string;
  deliveredQuantity: number;
  openQuantity: number;
  firstWeight: number;
  secondWeight: number;
  noPacking: number;
  packingWeight: number;
  perPackingWeight: number;
  storageLocation: string;
  deliveryStatus: string;
  wasteHandoverPlanCode: string;
  taskStatusCode: string;
  taskStatusName: string;
  color?: string;
  backgroundColor?: string;
};

export interface WasteHazardousWasteQuantityOverviewReportResponse {
  columns: Column[]
  rows: RowHazardous[]
  total: Total
  paging: Paging
}

export interface Column {
  title: string
  dataIndex: string
  groupTitle: string
  year: string
  month: string
}

export interface RowHazardous {
  ProductName: string
  IsRan: number
  IsLong: number
  IsKhi: number
  WasteGroupingEnvironmentPermitCode: number
  GPMTYearQty: any
  UnitName?: string
  VendorName: string
  Note: string
  M_202601: number
  TotalByTypeKg: number
}

export interface Total {
  ProductName: string
  IsRan: number
  IsLong: number
  IsKhi: number
  WasteGroupingEnvironmentPermitCode: any
  GPMTYearQty: any
  UnitName: any
  VendorName: any
  Note: any
  M_202601: number
  TotalByTypeKg: number
}
export interface Paging {
  totalCount: number
  pageIndex: number
  pageSize: number
  totalPages: number
}

// ============ Khai báo phương thức =====================
export interface IReportServices {
  //====================== BÁO CÁO DANH SÁCH ĐĂNG KÝ XE =================================================
  // search
  getListReportDeliveryRegistration(data: SearchDeliveryRegistrationReport): Promise<DataResponse<DeliveryRegistrationReport[]>>;
  // Export excel
  exportListReportDeliveryRegistration(data: SearchDeliveryRegistrationReport): Promise<void>;
  //====================== BÁO CÁO DANH SÁCH ĐĂNG KÝ BÀN GIAO CHẤT THẢI/PHẾ LIỆU ========================
  // search
  getWasteHandoverRegistrationReport(data: SearchWasteHandoverRegistrationReport): Promise<DataResponse<WasteHandoverRegistrationReport[]>>;
  // Export excel
  exportWasteHandoverRegistrationReport(data: Omit<SearchWasteHandoverRegistrationReport, 'paging'>): Promise<void>;
  //====================== BÁO CÁO KẾT QUẢ GIAO HÀNG =================================================
  //  Search
  getReportDeliveryResult(data: SearchDeliveryResultReport): Promise<DataResponse<DeliveryResultReport[]>>
  // Export excel
  exportReportDeliveryResult(data: Omit<SearchDeliveryResultReport, 'paging'>): Promise<void>;
  //====================== BÁO CÁO RECEIVING-SCHEDULE-OF-BHF =================================================
  // search
  getReceivingSchedulReport(data: SearchReceivingScheduleOfBHFReport): Promise<DataResponse<ReceivingScheduleOfBHFReport[]>>
  // Export excel
  exportReceivingSchedulReport(data: Omit<SearchReceivingScheduleOfBHFReport, 'paging'>): Promise<void>;
  //====================== BÁO CÁO KẾT QUẢ GỬI EMAIL =========================================================
  // Search
  getEmailSendingReport(data: SearchEmailSendingReport): Promise<DataResponse<EmailSendingReport[]>>;
  // Export excel
  exportEmailSendingReport(data: Omit<SearchEmailSendingReport, 'paging'>): Promise<void>;
  //====================== BÁO CÁO TỔNG HỢP CHẤT THẢI/PHẾ LIỆU ===============================================
  // Search
  getWasteSummaryReport(data: SearchWasteSummaryReport): Promise<DataResponse<WasteSummaryReportItem[]> & { totalQuantity?: number }>;
  // Export excel
  exportWasteSummaryReport(data: SearchWasteSummaryReport): Promise<void>;

  // báo cáo chất tổng hợp chất thải nguy hại
  reportHazardousWasteQuantityOverview(data: object): Promise<DataResponse<WasteHazardousWasteQuantityOverviewReportResponse | undefined>>;
  exportHazardousWasteQuantityOverview(data: object): Promise<void>;

  // báo cáo tổng hợp khối lượng chất thải công nghiệp thông thường & chất thải rắn sinh hoạt
  reportNoneHazardousWasteQuantityOverview(data: object): Promise<DataResponse<WasteHazardousWasteQuantityOverviewReportResponse | undefined>>;
  exportNoneHazardousWasteQuantityOverview(data: object): Promise<void>;
}
// Hàm khởi tạo các phương nhà của NKMH service
export function createReportServices(): IReportServices {
  return {
    //====================== BÁO CÁO DANH SÁCH ĐĂNG KÝ XE =================================================
    // search
    getListReportDeliveryRegistration: async (data) => {
      return (await post(MASTER_DATA_API_URL, `report/report-list-delivery-registration`, data)).data;
    },
    // Export excel
    exportListReportDeliveryRegistration: async (data) => {
      return (await downloadFilePost(MASTER_DATA_API_URL, `report/export-report-list-delivery-registration`, data));
    },
    //====================== BÁO CÁO DANH SÁCH ĐĂNG KÝ BÀN GIAO CHẤT THẢI/PHẾ LIỆU ========================
    // search
    getWasteHandoverRegistrationReport: async (data) => {
      return (await post(MASTER_DATA_API_URL, `report/report-list-waste-handover-registration`, data)).data;
    },
    // Export excel
    exportWasteHandoverRegistrationReport: async (data) => {
      const { paging, ...exportData } = data as SearchWasteHandoverRegistrationReport;
      return (await downloadFilePost(MASTER_DATA_API_URL, `report/export-report-list-waste-handover-registration`, exportData));
    },
    //====================== BÁO CÁO KẾT QUẢ GIAO HÀNG =================================================
    // search
    getReportDeliveryResult: async (data) => {
      return (await post(MASTER_DATA_API_URL, `report/report-delivery-registration-result`, data)).data;
    },
    // Export excel
    exportReportDeliveryResult: async (data) => {
      return (await downloadFilePost(MASTER_DATA_API_URL, `report/export-report-delivery-registration-result`, data));
    },
    //====================== BÁO CÁO RECEIVING-SCHEDULE-OF-BHF =================================================
    // search
    getReceivingSchedulReport: async (data) => {
      return (await post(MASTER_DATA_API_URL, `report/receiving-schedule-of-bhf`, data)).data;
    },
    // Export excel
    exportReceivingSchedulReport: async (data) => {
      return (await downloadFilePost(MASTER_DATA_API_URL, `report/export-receiving-schedule-of-bhf`, data));
    },
    // ======================= Báo cáo kết quả gửi email =========================================================
    getEmailSendingReport: async (data) => {
      return (await post(MASTER_DATA_API_URL, `report/report-send-email`, data)).data;
    }
    ,
    exportEmailSendingReport: async (data) => {
      return (await downloadFilePost(MASTER_DATA_API_URL, `report/export-report-send-email`, data));
    },
    // ======================= Báo cáo tổng hợp chất thải/phế liệu =========================================
    getWasteSummaryReport: async (data) => {
      const response = await post(MASTER_DATA_API_URL, `report/waste-summary-report`, data);
      // totalQuantity nằm trong response.data (cùng level với data array)
      const apiResponse = response.data as any;
      return {
        ...apiResponse,
        data: apiResponse.data || [],
        totalQuantity: apiResponse.totalQuantity,
      };
    },
    exportWasteSummaryReport: async (data) => {
      return (await downloadFilePost(MASTER_DATA_API_URL, `report/export-waste-summary-report`, data));
    },

    // báo cáo chất tổng hợp chất thải nguy hại
    reportHazardousWasteQuantityOverview: async (data) => {
      return (await post(MASTER_DATA_API_URL, `report/report-hazardous-waste-quantity-overview`, data)).data;
    },
    exportHazardousWasteQuantityOverview: async (data) => {
      return (await downloadFilePost(MASTER_DATA_API_URL, `report/export-report-hazardous-waste-quantity-overview`, data));
    },

    // báo cáo tổng hợp khối lượng chất thải công nghiệp thông thường & chất thải rắn sinh hoạt
    reportNoneHazardousWasteQuantityOverview: async (data) => {
      return (await post(MASTER_DATA_API_URL, `report/report-none-hazardous-waste-quantity-overview`, data)).data;
    },
    exportNoneHazardousWasteQuantityOverview: async (data) => {
      return (await downloadFilePost(MASTER_DATA_API_URL, `report/export-report-none-hazardous-waste-quantity-overview`, data));
    },
  };
}
